<script lang="ts" setup>
import type {BlockNode} from '#strapi-blocks-renderer/types';
import type {ComponentLayoutTextImage} from '~~/types/strapi-blog';

const props = defineProps<ComponentLayoutTextImage>();

const sectionOrientation = computed(() => props.textImageOrientation ?? 'horizontal')
const sectionReverse = computed(() => props.reverseOrder ?? false)
const strapiImageUrl = computed(() =>
    props.image?.url ? useStrapiMedia(props.image.url) : null
)

const nodes = computed(() => Array.isArray(props.content) ? props.content : [])

const sectionUi = computed(() => ({
    container: props.description
        ? 'sm:gap-8'
        : 'sm:gap-16 py-8 sm:py-8 lg:py-8 gap-16 sm:gap-8',
}))

</script>

<template>
    <UPageSection
        :orientation="sectionOrientation"
        :reverse="sectionReverse"
        :ui="sectionUi"
        class="lg:first:pt-12"
    >
        <template #body>
            <div
                v-if="nodes.length"
                class="flex flex-col"
            >
                <slot name="title">
                    <h2
                        v-if="props.title"
                    >
                        {{ props.title }}
                    </h2>
                </slot>
                <slot name="description">
                    <p
                        v-if="props.description"
                        class="font-bold"
                    >
                        {{ props.description }}
                    </p>
                </slot>
                <div
                >
                    <StrapiBlocksText :nodes="nodes"/>
                </div>
            </div>
        </template>
        <template #default>
            <div
                v-if="strapiImageUrl"
                :class="props.reverseOrder ? 'order-1' : 'order-2'"
            >
                <NuxtImg
                    :alt="props.image?.alternativeText ?? ''"
                    :src="strapiImageUrl"
                    class="w-full max-h-120 object-cover object-center rounded-lg drop-shadow-lg"
                    format="webp"
                    sizes="100vw lg:560px"
                />
            </div>
        </template>
    </UPageSection>
</template>
